import React, {createContext, useState} from 'react';
import PMSCompanyService from "../../services/pms_services/PMSCompanyService";
import {getPharmacyId} from "../../helpers/Utils";
import Notification from "../../components/common/Notification";

export const PMSCompanyContext = createContext("PMSCompanyContext");


const PMSCompanyContextProvider = ({children}) => {

    const [companies, setCompanies] = useState([]);
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [totalElements, setTotalElements] = useState(0);

    const pharmacyId = getPharmacyId();

    async function getAllCompanies(data) {

        try {
            setLoading(true);
            setErrorMsg('');
            // const res = await PMSCompanyService.getAllCompanies(pharmacyId,{page, size, id, companyName});
            const res = await PMSCompanyService.getAllCompanies(pharmacyId, data);
            setTotalElements(res.data.totalElements);
            setCompanies(res.data.content);
            setLoading(false);
            return res.data.content;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Companies. Please check the console.");
            console.log("error", console.error());
            return false;
        }

    }


    async function getCompanyById(id) {

        try {
            setLoading(true);
            setErrorMsg('');
            const res = await PMSCompanyService.getCompanyById(id, pharmacyId);
            setCompany(res.data);
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Company. Please check the console.");
            console.log("error", console.error());
            return false;
        }

    }

    async function addCompany(data) {

        try {
            setErrorMsg('');
            setLoading(true);
            const res = await PMSCompanyService.addCompany(data, pharmacyId)
            setCompanies(companies ? [...companies, res.data] : [res.data]);
            setLoading(false);
            return res.data;
        } catch (error) {
            setLoading(false);

            let _error = "Something went wrong.";

            if (error.message === "Network Error") {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    async function updateCompany(DATA, id) {
        try {
            setLoading(true);
            setErrorMsg('');
            const res = await PMSCompanyService.updateCompany(DATA, id, pharmacyId);
            setCompany(res.data);
            let updatedCompanies = companies;
            updatedCompanies = companies.map(e => {
                if (e.id === id) e = res.data;
                return e;
            })

            setCompanies(updatedCompanies);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not update Company. Please check the console.");
            console.log("Company update error.", error);
            return false;
        }

    }

    async function deleteCompany(id) {

        if (!window.confirm("Are you sure you want to delete this Company ?")) return;

        try {
            setLoading(true);
            setErrorMsg('');
            await PMSCompanyService.deleteCompany(id, pharmacyId);
            let updatedCompanies = companies;
            updatedCompanies = companies.filter(e => e.id !== id);
            setCompanies(updatedCompanies);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not delete Companies. Please check the console.");
            console.log("Company delete error.", error);
            return false;
        }
    }


    return (
        <PMSCompanyContext.Provider
            value={{
                companies,
                company,
                loading,
                errorMsg,
                totalElements,
                getAllCompanies,
                updateCompany,
                getCompanyById,
                deleteCompany,
                addCompany
            }}
        >
            {children}
        </PMSCompanyContext.Provider>
    );
}

export default PMSCompanyContextProvider;